import "./Handbag.css"
import Product1 from "../Components/Product1"

import Handbag1 from "../images/h1.jpg"
import Handbag2 from "../images/h2.jpg"
import Handbag3 from "../images/h3.jpg"
import Handbag4 from "../images/h4.jpg"
import Handbag5 from "../images/h5.jpg"
import Handbag6 from "../images/h6.jpg"
import Handbag7 from "../images/h7.jpg"
import Handbag8 from "../images/h8.jpg"
import Handbag9 from "../images/bagwadd.jpg"

export default function Handbag() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Handbag9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <strong><Product1  id="hbag1"  prdName="VOGUE" img={Handbag1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1></strong>
            <strong>  <Product1 id="hbag2" prdName="SKYBAG" img={Handbag2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          </strong>

          </div>

          <div className="home__prd1">

          
          <Product1 id="hbag3" prdName="MYLAAYC" img={Handbag3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="hbag4" prdName="DOGRIE" img={Handbag4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="hbag5" prdName="GREENWOOD" img={Handbag5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="hbag6" prdName="CLASSIC" img={Handbag6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1  id="hbag7"prdName="VOGUE" img={Handbag7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="hbag8"prdName="CMAS" img={Handbag8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}